export default __webpack_public_path__ + "static/media/home_tag.42413230.gif";